import { isEmpty } from 'lodash'

export function isReserveVehicle(vehicle) {
    return vehicle.status === 'SP' && (vehicle.vin.trim() === '' || !vehicle.vin)
}

export function isPreRegisterVehicle(vehicle) {
    return vehicle.status === "SP" && vehicle.vin && (vehicle.vin.length >= 6)
}

export function isSentToAs400(vehicle) {
    return vehicle.resultType === "R" && !(vehicle.status === 'SP' && (vehicle.vin.trim() === '' || !vehicle.vin))
}

// Maps the AS400-persisted vehicleSaleType reference code (as returned by /vehicle/inventory-search
// for vehicles already sitting in the lane) to its display name. Null/blank means the vehicle is on
// the lane's default sale type.
const VEHICLE_SALE_TYPE_LABELS = {
    HVYT: 'Heavy Truck',
    MDMT: 'Medium Truck'
}

export function getVehicleSaleTypeLabel(vehicleSaleType) {
    if (!vehicleSaleType) {
        return 'Lane Default'
    }
    return VEHICLE_SALE_TYPE_LABELS[vehicleSaleType] || vehicleSaleType
}

// vehicleType code for Trailer - the one vehicleType value that makes a vehicle PAT-eligible on its
// own, regardless of weightClass (2026-09-03 clarification).
const VEHICLE_TYPE_TRAILER = 'A'

// A weightClass of '0' (string, as AS400 sends it) means "no weight class assigned" - the same as
// blank/null/'' - not a real weight class value, so it must be treated as blank rather than a
// truthy string (2026-09-05 clarification).
function isBlankWeightClass(weightClass) {
    return !weightClass || weightClass === '0'
}

// Change request (2026-08-28, refined 2026-09-03/2026-09-05): PAT has nothing to decide for a
// vehicle unless it's a Trailer (vehicleType === 'A', eligible regardless of weightClass) or it
// carries a real weight class. Any other vehicleType value does NOT make the vehicle PAT-eligible
// by itself - with no weight class, it's still skipped. Used both to skip calling PAT at assignment
// time (force Lane Default instead) and, in SaleTypeEligibilityStatus, to render the vehicle as a
// plain Lane Default/no-override row instead of running any PAT-driven display logic (US2165220).
export function isPatIneligibleVehicle(vehicle) {
    if (vehicle?.vehicleType === VEHICLE_TYPE_TRAILER) {
        return false
    }
    return isBlankWeightClass(vehicle?.weightClass)
}

export function preregisteredVehicleDescription(vehicle){
    let validAttributes = ''
    if(isEmpty(vehicle)) {
        return ''
    }

    if(vehicle.year && vehicle.year !== 0 ) {
        validAttributes += vehicle.year + ' '
    }

    if(vehicle.make !== "") {
        validAttributes += vehicle.make + ' '
    }

    if(vehicle.model !== "") {
        validAttributes += vehicle.model + ' '
    }

    if(vehicle.trim !== "") {
        validAttributes += vehicle.trim + ' '
    }

    if(vehicle.exteriorColor && vehicle.exteriorColor !=="") {
        validAttributes += vehicle.exteriorColor
    }

    return validAttributes.toUpperCase()
}

export function getPreregisteredTitle(vehicle){
    let titlePreregistered = ''
    if(isEmpty(vehicle)) {
        return ''
    }

    if(vehicle.year && vehicle.year !== 0 ) {
        titlePreregistered += vehicle.year + ' '
    }

    if(vehicle.make !== "") {
        titlePreregistered += vehicle.make + ' '
    }

    if(vehicle.model !== "") {
        titlePreregistered += vehicle.model + ' '
    }

    if(vehicle.trim !== "") {
        titlePreregistered += vehicle.trim + ' '
    }

    return titlePreregistered
}

